// export const ADDRS = {
//   V3_FACTORY: "0xF795f3cF3e65B2aC4592Cae6528d7E2dC1ca9d6f",
//   POSITION_MANAGER: "0xCAea66b7F345bc39c45fbbC822411181C0a252f2",
//   SWAP_ROUTER: "0x9BC8408C4874A55ce3fF27d4bB5A2aF45bCbFaa2",
//   QUOTER_V2: "0xD0595426C0Eaa805CA4b8a886383352833024e8F", // ← paste EXACT from your logs
//   weth9: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
//   WETHW: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
//   TOKEN0: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
//   LOCKER_ADDRESS: "0x72C516362b3bf8FD2705cCFe5f35119884278Eb0",
//   // TOKEN1: "0x9Ef4e894a91CD8F555Df33a81a11851CaCf7432a",
//   FEE: 3000,
// };

// =======================live addresss prod=======================
export const ADDRS = {
  V3_FACTORY: "0xdc4ffc7665087e15e30037223a6df4a90c63e332",
  POSITION_MANAGER: "0x3f08213f8d29f209b6665b6855a64f6791368ec4",
  SWAP_ROUTER: "0xc1c4c18b2ee1dfeda5a63a33171845b2916d1ba1",
  QUOTER_V2: "0xd089318F490aaD91AA536273026831537223D545",
  weth9: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  WETHW: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  TOKEN0: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  LOCKER_ADDRESS: "0x934389f8B37E40098505cF381f882Fb9D83C3491",
  FEE: 3000,
}; //Live

//=======================test addresss prod=======================
// export const ADDRS = {
//   V3_FACTORY: "0x4121f8528112E97D992c208B10c859573f23dA05",
//   POSITION_MANAGER: "0xE2FCcb32b62163986A552d6AFe59DFee7227D81a",
//   SWAP_ROUTER: "0xe03d80761fc9B45CcfbAbA899DE2d9dE9D6c1a9A",
//   QUOTER_V2: "0x7Fae695C16d993B63D2cB353B15424f93520EdB4",
//   weth9: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
//   WETHW: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
//   TOKEN0: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
//   LOCKER_ADDRESS: "0xFF77744D8BC8c8F2d331F363AAFf8A79f4888540",
//   FEE: 3000,
// };
